import { Injectable } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';

import { PersonnelVersion } from '@shared/enums';
import { ProjectSetup } from '@shared/models';
import { DprPersonnelDetail, WorkedHoursDetails } from '@shared/models/dpr';
import { DailyStockService } from '.';

@Injectable()
export class WorkedHoursService {
  constructor(private dailyStockService: DailyStockService) {}

  onPreviousDayChanged(
    previousItem: DprPersonnelDetail,
    currentItem: DprPersonnelDetail,
    projectSetup: ProjectSetup
  ): WorkedHoursDetails {
    if (!currentItem) {
      return null;
    }

    if (!previousItem || !previousItem.workedHoursDetails) {
      return currentItem.workedHoursDetails;
    }

    const dprPersonnelDetails = { ...currentItem };

    dprPersonnelDetails.workedHoursDetails = {
      ...(dprPersonnelDetails.workedHoursDetails ?? {}),
    };

    dprPersonnelDetails.workedHoursDetails.previousTotalToDate =
      previousItem.workedHoursDetails.totalToDate || 0;

    return this.computeWorkedHoursDetails(dprPersonnelDetails, projectSetup);
  }

  computeWorkedHoursDetails(
    dprPersonnelDetails: DprPersonnelDetail,
    projectSetup: ProjectSetup
  ): WorkedHoursDetails {
    const personnelVersion =
      projectSetup?.subprojectConfiguration?.personnelVersion;

    if (!dprPersonnelDetails || !personnelVersion) {
      return null;
    }

    const workedHoursDetails = cloneDeep(
      dprPersonnelDetails.workedHoursDetails ?? {}
    );
    switch (personnelVersion) {
      case PersonnelVersion.Stock:
        const dailyStockDetails = dprPersonnelDetails.dailyStockDetails ?? {};
        workedHoursDetails.total = this.isDprPersonnelDetailsCompleted(
          dprPersonnelDetails
        )
          ? (dailyStockDetails.totalEndOfDay ?? 0) *
            dprPersonnelDetails.workedHours
          : null;
        break;
      case PersonnelVersion.Classic:
        workedHoursDetails.total = this.isDprPersonnelDetailsCompleted(
          dprPersonnelDetails
        )
          ? (dprPersonnelDetails.currentDay ?? 0) *
            dprPersonnelDetails.workedHours
          : null;
        break;
    }

    workedHoursDetails.totalToDate =
      (workedHoursDetails.total ?? 0) +
      (workedHoursDetails.previousTotalToDate ?? 0);
    return workedHoursDetails;
  }

  isDprPersonnelDetailsCompleted(
    dprPersonnelDetail: DprPersonnelDetail
  ): boolean {
    return (
      dprPersonnelDetail.workedHours != null &&
      (this.dailyStockService.isDailyStockActionCompleted(dprPersonnelDetail) ||
        this.dailyStockService.isDailyClassicActionCompleted(
          dprPersonnelDetail
        ) ||
        this.dailyStockService.hasTotalEndOfDay(
          dprPersonnelDetail.dailyStockDetails
        ))
    );
  }
}
